import angular from 'angular';
import dashboardComponent from './dashboard.component';

let dashboardModule = angular.module('dashboard', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('dashboard', dashboardComponent);

export default dashboardModule;



// WEBPACK FOOTER //
// ./client/pages/admin/dashboard/dashboard.js